<template>
    <div>
        <v-dialog v-model="dialog" persistent width="500">
            <v-card>
                <v-toolbar color="primary" dark flat dense cad>
                    <v-toolbar-title class="subheading">{{labeldialog}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closedialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="text-xs-left">
                    <v-form ref="form" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col cols="6" lg="6">
                                    <v-text-field readonly label="OderId" name="name" v-model="selectedOrder.id"></v-text-field>
                                </v-col>
                                <v-col cols="6" lg="6">
                                    <v-text-field readonly label="Invoice" name="name" v-model="selectedOrder.invoice"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12 ">
                                    <v-text-field readonly label="Harga" name="name" v-model="selectedOrder.price"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-text-field readonly label="Jumlah Token" name="name" v-model="selectedOrder.totaltokensms"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-text-field readonly label="NoVa" name="name" v-model="selectedOrder.nova"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text dark @click="closedialog" color="red">Tutup</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-tabs  v-model="tab">
            <v-tab>Order List</v-tab>
            <v-tab>Histori Token</v-tab>
            <v-tab>
                <v-badge
                        color="deep-orange accent-4"
                        icon="fiber_new"
                        content="NEW"
                >
                    Pengaturan
                </v-badge>
                </v-tab>
            <v-tab-item>
                <div class="mt-4 pr-2 pl-2 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
                    <v-toolbar elevation="0">
                        <v-text-field
                                flat
                                solo
                                dense
                                prepend-inner-icon="search"
                                label="Search"
                                placeholder="Type something"
                                v-model="search"
                                hide-details
                                class="hidden-sm-and-down"
                        ></v-text-field>
                        <v-spacer></v-spacer>
                                <div class="mt-6">
                                    <v-menu
                                            v-model="menuorder1"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="20px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                    v-model="opsitableorder.awal"
                                                    label="Tanggal Awal"
                                                    prepend-icon="event"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="opsitableorder.awal" @input="menuorder1 = false"></v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="mt-6">
                                    <v-menu
                                            v-model="menuorder2"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                    v-model="opsitableorder.akhir"
                                                    label="Tanggal Akhir"
                                                    prepend-icon="event"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="opsitableorder.akhir" @input="menuorder2 = false"></v-date-picker>
                                    </v-menu>
                                </div>
                            <v-btn @click="goOrderPage" class="ml-2" color="primary">
                                <v-icon dark>add</v-icon>
                                Beli</v-btn>
                            <v-btn class="ml-2" color="primary" @click.native="getOrders(opsitableorder)">
                                <v-icon dark>refresh</v-icon>Refresh
                            </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-data-table
                            :headers="headerOrders"
                            :search="opsitableorder.search"
                            :items="orders"
                            class="elevation-0"
                            item-key="id"
                            :options.sync="opsitableorder"
                            :server-items-length="ordertotal"
                            :loading="loading"
                            @update:options="getOrders(opsitableorder)"
                    >
                        <template class="hidden-sm-and-down" v-slot:body.append>
                            <tr class="hidden-sm-and-down">
                                <td colspan="4"></td>
                                <td class="text-end">
                                    Total:
                                </td>
                                <td class="text-end">
                                   {{formatAngka(totaltoken)}}
                                </td>
                                <td class="text-end">
                                    {{formatAngka(totalamountorder)}}
                                </td>
                                <td colspan="4"></td>
                            </tr>
                        </template>
                        <template v-slot:item.totaltokensms="{ item }">
                            <div class="">
                                {{formatAngka(item.totaltokensms)}}
                            </div>
                        </template>
                        <template v-slot:item.createdat="{ item }">
                            {{formatDate(item.createdat)}}
                        </template>
                        <template v-slot:item.price="{ item }">
                            <div class="">
                                {{formatAngka(item.price)}}
                            </div>
                        </template>
                        <template v-slot:item.status="{ item }">
                            <div class="ma-4 text-xs-left">
                                <v-chip
                                        v-if="item.status===1"
                                        color="green"
                                        small
                                        text-color="white"
                                >{{ statusText(item.status) }}</v-chip>
                                <v-chip
                                        v-else
                                        color="orange"
                                        small
                                        text-color="white"
                                >{{ statusText(item.status) }}</v-chip>
                            </div>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <div class="ma-4 text-xs-left">
                                <v-btn @click.native="openFormEdit(item)" icon small>
                                    <v-icon color="primary">edit</v-icon>
                                </v-btn>
                            </div>
                        </template>
                    </v-data-table>
                </div>
            </v-tab-item>
            <v-tab-item>
                <div class="mt-4 pr-2 pl-2 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
                    <v-toolbar elevation="0">
                        <v-text-field
                                flat
                                solo
                                prepend-icon="search"
                                placeholder="Type something"
                                v-model="search"
                                hide-details
                                class="hidden-sm-and-down"
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <div class="mt-6">
                            <v-menu
                                    v-model="menu1"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                            v-model="opsitablehistori.awal"
                                            label="Tanggal Awal"
                                            prepend-icon="event"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="opsitablehistori.awal" @input="menu1 = false"></v-date-picker>
                            </v-menu>
                        </div>
                        <div class="mt-6">
                            <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                            v-model="opsitablehistori.akhir"
                                            label="Tanggal Akhir"
                                            prepend-icon="event"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="opsitablehistori.akhir" @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </div>
                        <v-btn class="ml-2" color="primary" @click.native="getHistoriToken(opsitablehistori)">
                            <v-icon dark>refresh</v-icon>Refresh
                        </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-data-table
                            :headers="headerHisToken"
                            :search="search"
                            :items="historitoken"
                            class="elevation-0"
                            item-key="id"
                            :options.sync="opsitablehistori"
                            :server-items-length="historitotal"
                            :loading="loading"
                            @update:options="getHistoriToken(opsitablehistori)"
                    >
                        <template v-slot:item.totaltokensms="{ item }">
                            <div class="text-right">
                                {{formatAngka(item.totaltokensms)}}
                            </div>
                        </template>
                        <template v-slot:item.createdat="{ item }">
                                {{formatDate(item.createdat)}}
                        </template>
                        <template v-slot:item.sisa="{ item }">
                            <div class="">
                                {{formatAngka(item.sisa)}}
                            </div>
                        </template>
                        <template v-slot:item.price="{ item }">
                            <div class="text-right">
                                {{formatAngka(item.price)}}
                            </div>
                        </template>
                        <template v-slot:item.status="{ item }">
                            <div class="ma-4 text-xs-left">
                                <v-chip
                                        v-if="item.status===1"
                                        color="green"
                                        small
                                        text-color="white"
                                >{{ statusText(item.status) }}</v-chip>
                                <v-chip
                                        v-else
                                        color="orange"
                                        small
                                        text-color="white"
                                >{{ statusText(item.status) }}</v-chip>
                            </div>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <div class="ma-4 text-xs-left">
                                <v-btn @click.native="openFormEdit(item)" icon small>
                                    <v-icon color="primary">edit</v-icon>
                                </v-btn>
                            </div>
                        </template>
                    </v-data-table>
                </div>
            </v-tab-item>
            <v-tab-item>
                <v-col cols="12" lg="4" md="6">
                    <v-text-field type="number" v-model="application.maxotp" label="Max Ulang OTP per hari"></v-text-field>
                </v-col>
                <v-col cols="12" lg="4">
                    <v-spacer></v-spacer>
                    <v-btn @click="updateOTPmax" class="primary">Simpan</v-btn>
                </v-col>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
    import {mapState,mapActions} from "vuex";
    import moment from "moment";

    export default {
        name: "SMSTokenPage",
        data: () => ({
            labeldialog: 'Detail',
            tab: null,
            search: '',
            maxotp: 2,
            dateawal: moment().add(7,'hours').toISOString().substr(0, 10),
            dateakhir: moment().add(7,'hours').toISOString().substr(0, 10),
            menu2: false,
            menu1: false,
            menuorder1: false,
            menuorder2: false,
            valid: false,
            selectedOrder: {},
            selected: {},
            opsitablehistori: {
                search:'',
                itemsPerPage: 10,
                page:1,
                sortBy: ["id"],
                awal: moment().add(7,'hours').toISOString().substr(0, 10),
                akhir: moment().add(7,'hours').toISOString().substr(0, 10),
            },
            opsitableorder: {
                search:'',
                itemsPerPage: 10,
                page:1,
                sortBy: ["id"],
                awal: moment().add(7,'hours').toISOString().substr(0, 10),
                akhir: moment().add(7,'hours').toISOString().substr(0, 10),
            },
            headerHisToken: [
                {
                    text: 'id',
                    value: 'id'
                },
                {
                    text: 'Phone',
                    value: 'phone'
                },
                {
                    text: 'SenderID',
                    value: 'senderid'
                },
                {
                    text: 'Amount',
                    value: 'amount'
                },
                {
                    text: 'Sisa',
                    value: 'sisa'
                },
                {
                    text: 'Created At',
                    value: 'createdat'
                }
            ],
            headerOrders: [
                {
                    text: 'id',
                    value: 'id'
                },
                {
                    text: 'Paket',
                    value: 'paketId'
                },
                {
                    text: 'Invoice',
                    value: 'invoice'
                },
                {
                    text: 'Status',
                    value: 'status'
                },
                // {
                //     text: 'BCA VA',
                //     value: 'nova'
                // },
                // {
                //     text: 'BRI VA',
                //     value: 'briva'
                // },
                {
                    text: 'Description',
                    value: 'description'
                },
                {
                    text: 'Jumlah Token',
                    value: 'totaltokensms',
                    align: 'end'
                },
                {
                    text: 'Harga',
                    value: 'price',
                    align: 'end'
                },
                {
                    text: 'Waktu',
                    value: 'createdat'
                },
                {
                    text: 'Action',
                    value: 'action',
                    sortable: false
                }
            ],
        }),
        watch: {
        },
        mounted(){
            this.getOrders(this.opsitableorder)
            this.getHistoriToken(this.opsitablehistori)
        },
        computed: {
            ...mapState('TokenSMS', ['orders','ordertotal','historitotal','totaltoken','totalamountorder', 'dialog', 'loading','historitoken']),
            ...mapState('applikasi',['application'])
        },
        methods: {
            ...mapActions('TokenSMS',['getOrders','getHistoriToken','closedialog','opendialog']),
            ...mapActions('applikasi',['setmaxOTP']),
            goOrderPage(){
                this.$router.push('/tokensms/order/create');
            },
            statusText(status){
                if(status===0){
                    return "Menunggu Pembayaran"
                }
                if(status===1   ){
                    return "Sukses"
                }
            },
            updateOTPmax(){
              this.setmaxOTP(this.application.maxotp);
            },
            openFormEdit(item){
                this.selectedOrder=item;
                this.opendialog();
            },
            formatDate (value) {
                return moment(value).add(7,'hours').format("YYYY/MM/DD HH:mm:ss")
            },
            formatAngka(angka) {
                var rev = parseInt(angka, 10).toString().split('').reverse().join('');
                var rev2 = '';
                for (var i = 0; i < rev.length; i++) {
                    rev2 += rev[i];
                    if ((i + 1) % 3 === 0 && i !== (rev.length - 1)) {
                        rev2 += '.';
                    }
                }
                return rev2.split('').reverse().join('').toString();
            }
        }
    }
</script>

<style scoped>

</style>
